import type { Column } from '@app/components/base/Table/types'
import type { GetColumnsFromMapOptions } from '@app/types/table'

const getAppliedOption = <DataType extends object>(
  key: string,
  options?: Array<Column<DataType>>
): Omit<Column<DataType>, 'key'> | undefined => options?.find(option => option.key === key)

const getColumnsFromMap = <DataType extends object>({
  columnTitleMap,
  options
}: GetColumnsFromMapOptions<DataType>): Array<Column<DataType>> =>
    Object.entries(columnTitleMap).map(([key, value]) => ({
      key,
      dataIndex: key,
      title: value as string,
      ...getAppliedOption<DataType>(key, options)
    }))

export default getColumnsFromMap
